import { render } from "./Profile.vue?vue&type=template&id=5856a0ea&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=5856a0ea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5856a0ea"

export default script